import { Component, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router } from '@angular/router';
import { Burns } from 'src/app/models/Burns';
import { Cards } from 'src/app/models/Cards';
import { Communications } from 'src/app/models/Communications';
import { Contacts } from 'src/app/models/Contacts';
import { CustomerInfo } from 'src/app/models/CustomerInfo';
import { ItemsOpenedFinished } from 'src/app/models/ItemsOpenedFinished';
import { Memberships } from 'src/app/models/Memberships';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { MainService } from 'src/app/services/delavci/main.service';
import { LoginPartnerService } from 'src/app/services/partner/login-partner/login-partner.service';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-helpdesk-tab',
  templateUrl: './helpdesk-tab.component.html',
  styleUrls: ['./helpdesk-tab.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class HelpdeskTabComponent implements OnInit {

  public periodSubscription;
  public contactIdOut;
  public sessionUser;
  public contactIdSelected;
  public periodTab;
  public basicLeft = []; public basicMiddle = []; public basicRight = [];
  public commBool = false; public itOpBool = false; public itFinBool = false; public burnsBool = false;
  public membershipBool = false; public contactsBool = false; public cardsBool = false;

  public displayedColumns: string[] = ['position', 'name'];
  // table communications
  displayedColumnsCommunication: string[] = ['booked', 'buildInSolution', 'communication', 'documentId', 'event', 'mailSentTo',
'nextContact', 'orderId', 'replied', 'status', 'text', 'timeSpend', 'wish', 'worker'];
  public dataSourceCommunication: Array<Communications>= [];
  // table ItemsOpenedFinished
  public displayedColumnsOpFin: string[] = ['documentId', 'warehouse', 'booked', 'created', 'status', 'documentSub'];
  public dataSourceItemsOpened: Array<ItemsOpenedFinished>= [];
  public dataSourceItemsFinished: Array<ItemsOpenedFinished>= [];
  public displayedColumnItems: string[] = ['itemCode', 'itemNamesmall', 'quantity', 'saleValue', 'discount'];
  // table Burns
  public displayedColumnsBurns: string[] = ['type', 'code', 'validFrom', 'validTo', 'quantity'];
  public dataSourceBurns: Array<Burns>= [];
  // table Memberships
  public displayedColumnsMemberships: string[] = ['code', 'nameSmall', 'started', 'voided', 'lastChanged', 'active'];
  public dataSourceMemberships: Array<Memberships>= [];
  // table Memberships
  public displayedColumnsContacts: string[] = ['code', 'name', 'surName', 'main', 'birthday', 'gender', 'street',
'mail', 'phone', 'post', 'country', 'spend'];
  public dataSourceContacts: Array<Contacts>= [];
  // table Memberships
  public displayedColumnsCards: string[] = ['code', 'main'];
    public dataSourceCards: Array<Cards>= [];
  // /table
  public itemOpArr: Array<ItemsOpenedFinished>= [];
  public itemFinArr: Array<ItemsOpenedFinished>= [];
  public expandedElementOp: Array<ItemsOpenedFinished> = [];
  public expandedElementFin: Array<ItemsOpenedFinished> = [];
  public isMobile;
  constructor(private helpdeskService: HelpdeskService, private mainService: MainService, private router: Router,
    private helpers: HelpersService, private deviceService: DeviceDetectorService) { }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
    //nastavi session in contactId
    this.mainService.changeHref(this.router.url);
    this.sessionUser = this.mainService.currentUserValue.sessionUser;
    this.helpdeskService.currentPeriodTab.subscribe( data => {
      this.periodSubscription = data;
    });
    this.checkStoragePartner();
    this.localstorageListener();
    this.helpdeskService.currentPeriodTab.subscribe(data => {
      this.periodTab = data;
      if(this.contactIdOut) {
        this.getCustomerInfoWS();
      }
    });
    //
    if(this.contactIdOut) {
      this.contactIdSelected = true;
      this.getCustomerInfoBasicWS();
      this.getCustomerInfoWS();
    } else {
      this.contactIdSelected = false;
    }
  }

  checkStoragePartner() {
    if(localStorage.getItem('tabContactId')) {
      this.contactIdOut = localStorage.getItem('tabContactId');
    }
  }

  localstorageListener() {
    window.addEventListener('storage', (event) => {
      if(event.key === 'tabContactId'){
        this.contactIdOut = event.newValue;
        this.contactIdSelected = true;
        this.getCustomerInfoBasicWS();
        this.getCustomerInfoWS();
      }
   });
  }

  getCustomerInfoBasicWS() {
   this.helpdeskService.getCustomerInfoBasic(this.sessionUser, this.contactIdOut).subscribe( data => {
    let info: CustomerInfo = data.data;
    this.basicLeft = [
      {position: 'Ime in priimek', name: info.partCode + ' ' + info.partTitle},
      //{position: 'Ime in priimek', name: info.partTitle},
      //
      {position: 'Rojstni dan', name: this.helpers.dateParserFromDayToYear(info.birthday)},
      {position: 'Spol', name: info.gender},
    ];
    this.basicMiddle = [
      {position: 'Email', name: info.mail},
      {position: 'Telefon', name: info.phone},
      {position: 'Naslov', name: info.partStreet + ', ' + info.post + ', ' + info.country},

    ];
    this.basicRight = [
      {position: 'Zapravila', name: info.spend},
      {position: 'Main', name: info.main},

    ];
    }, error => {
      console.log(error);
    });
  }

  getCustomerInfoWS() {
    this.helpdeskService.getCustomerInfo(this.sessionUser, this.contactIdOut, this.periodTab).subscribe( data => {
      let comArr: Array<Communications> = data.data.communication;
      for(let item of comArr) {
        item.booked = this.helpers.dateParserFromDayToMin(item.booked);
        item.event = this.helpers.dateParserFromDayToMin(item.event);
      }
      for(let item of comArr) {
        item.nextContact = this.helpers.dateParserFromDayToYear(item.nextContact);
      }
      this.dataSourceCommunication = comArr;

      this.itemOpArr = data.data.itemsOpened;
      for(let item of this.itemOpArr) {
        item.booked = this.helpers.dateParserFromDayToMin(item.booked);
        item.created = this.helpers.dateParserFromDayToMin(item.created);
      }
      let removedItemOpArr = this.removeDuplicateItems(this.itemOpArr);
      this.dataSourceItemsOpened = removedItemOpArr;

      this.itemFinArr = data.data.itemsFinished;
      for(let item of this.itemFinArr) {
        item.booked = this.helpers.dateParserFromDayToMin(item.booked);
        item.created = this.helpers.dateParserFromDayToMin(item.created);
      }

      let removedItemFinArr = this.removeDuplicateItems(this.itemFinArr);
      this.dataSourceItemsFinished = removedItemFinArr;

      let burnsArr: Array<Burns> = data.data.burns;
      for(let item of burnsArr) {
        item.validFrom = this.helpers.dateParserFromDayToYear(item.validFrom);
        item.validTo = this.helpers.dateParserFromDayToYear(item.validTo);
      }
      this.dataSourceBurns = burnsArr;

      let membershipsArr: Array<Memberships> = data.data.memberships;
      for(let item of membershipsArr) {
        item.started = this.helpers.dateParserFromDayToMin(item.started);
        item.voided = this.helpers.dateParserFromDayToMin(item.voided);
        item.lastChanged = this.helpers.dateParserFromDayToMin(item.lastChanged);
      }
      this.dataSourceMemberships = membershipsArr;

      let contactsArr: Array<Contacts> = data.data.contacts;
      for(let item of contactsArr) {
        item.birthday = this.helpers.dateParserFromDayToYear(item.birthday);
      }
      this.dataSourceContacts = contactsArr;
      this.dataSourceCards = data.data.cards;
    }, error => {
      console.log(error);
    });
  }

  removeDuplicateItems(itemArray: Array<ItemsOpenedFinished>) {
    let cleanArr: Array<ItemsOpenedFinished> = [];
    for(let item of itemArray) {
      if(cleanArr.length > 0) {
        var found = false;
        for(var i = 0; i < cleanArr.length; i++) {
            if (cleanArr[i].documentId == item.documentId) {
                found = true;
                break;
            }
        }
        if(!found) {
          cleanArr.push(item);
        }
      } else {
        cleanArr.push(item);
      }
    }
    return cleanArr;
  }

  getItemsOfDocId(newDocId, allItems: Array<ItemsOpenedFinished>) {
    let dataset: Array<ItemsOpenedFinished> = [];
    if(allItems){
      for(let item of allItems) {
        if(item) {
          if(newDocId === item.documentId) {
            dataset.push(item);
          }
        }

      }
  }
    return dataset;
  }

  //načeloma te kode ne bi bilo treba podvojiti, samo jo bom za vsak slučaj
  updateExpandTableListFin(element: ItemsOpenedFinished) {
   if(this.expandedElementFin.length > 0) {
    if(this.expandedElementFin.includes(element)){
      for(let i = 0; i < this.expandedElementFin.length; i++) {
        if(this.expandedElementFin[i] === element) {
          this.expandedElementFin[i] = null;
        }
      }
     } else {
       this.expandedElementFin.push(element);
     }
   }else {
    this.expandedElementFin.push(element);
  }

  }

  expandSelectedFin(element: ItemsOpenedFinished) {
    if(this.expandedElementFin.length > 0) {
      if(this.expandedElementFin.includes(element)) {
        return 'expanded';
      } else {
        return 'collapsed';
      }
    } else {
      return 'collapsed';
    }

    //element == expandedElementOp ? 'expanded' : 'collapsed'
  }

  updateExpandTableListOp (element: ItemsOpenedFinished) {
    if(this.expandedElementOp.length > 0) {
     if(this.expandedElementOp.includes(element)){
       for(let i = 0; i < this.expandedElementOp.length; i++) {
         if(this.expandedElementOp[i] === element) {
           this.expandedElementOp[i] = null;
         }
       }
      } else {
        this.expandedElementOp.push(element);
      }
    }else {
     this.expandedElementOp.push(element);
   }

  }

  expandSelectedOp(element: ItemsOpenedFinished) {
    if(this.expandedElementOp.length > 0) {
      if(this.expandedElementOp.includes(element)) {
        return 'expanded';
      } else {
        return 'collapsed';
      }
    } else {
      return 'collapsed';
    }
  }

  ifExists(dataSource: Array<Object>) {
    if(dataSource) {
      if(dataSource.length === 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  hammerSwipe(){
    if(this.isMobile){
      this.router.navigate(['/pregled-helpdeska']);
    }
  }

  selectPeriod(period) {
    this.helpdeskService.changePeriodTab(period);
  }

}
